import { graphql } from 'gatsby'
import StaticPage from '../views/staticPage'

export default StaticPage
export const query = graphql`
  query PersonalFinanceTncQuery($slug: String, $locale: String) {
    header: contentfulHeader(node_locale: { eq: $locale }) {
      ...headerFragment
    }
    footer: contentfulFooter(node_locale: { eq: $locale }) {
      ...footerFragment
    }
    waitingList: contentfulCtaSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...waitingListFragment
    }
    page: contentfulPage(slug: { eq: $slug }, node_locale: { eq: $locale }) {
      feature: pageSection {
        ...sectionHeadingFragment
        ...sectionTextFragment
      }
      metaDescription
      metaTag
      title
      slug
    }
  }
`
